'use strict';

require('./build/buildDateRangeUnitsCall');

// This package does not export anything as it is
// simply defining "days" on Range.prototype.


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/range/days.js
// module id = 390
// module chunks = 0